import React from "react";
import { useTranslation } from "react-i18next";
import { Globe, Check } from "lucide-react";
import { LANGUAGES } from "../i18n";
import {
  DropdownMenu, DropdownMenuTrigger, DropdownMenuContent,
  DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator,
} from "./ui/dropdown-menu";

export default function LanguageSwitcher({ compact = false }) {
  const { i18n, t } = useTranslation();
  const current = (i18n.resolvedLanguage || i18n.language || "en").split("-")[0];
  const currentLang = LANGUAGES.find((l) => l.code === current) || LANGUAGES[0];

  const change = (code) => {
    i18n.changeLanguage(code);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        data-testid="language-switcher-trigger"
        aria-label={t("language.label")}
        className={`inline-flex items-center gap-2 rounded-full border border-[#E8DEC8] dark:border-[#423B36] bg-white/70 dark:bg-[#221E1C] px-3 py-1.5 text-sm text-[#2C2623] dark:text-[#FAF5F0] hover:bg-[#F9F5EE] dark:hover:bg-[#2A2422] transition-colors ${compact ? "" : "font-medium"}`}>
        <Globe className="w-4 h-4 text-[#6E655F] dark:text-[#B5AAA1]" />
        <span data-testid="language-switcher-current">{currentLang.native}</span>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-52" data-testid="language-switcher-menu">
        <DropdownMenuLabel className="text-xs uppercase tracking-widest text-[#6E655F]">
          {t("language.choose")}
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        {LANGUAGES.map((l) => (
          <DropdownMenuItem
            key={l.code}
            onClick={() => change(l.code)}
            data-testid={`language-option-${l.code}`}
            className="flex items-center justify-between cursor-pointer">
            <span className="flex flex-col">
              <span className="font-medium">{l.native}</span>
              <span className="text-xs text-[#6E655F]">{l.label}</span>
            </span>
            {l.code === current && <Check className="w-4 h-4 text-[#D95D39]" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
